import { createAction } from "@reduxjs/toolkit";

export const LOCATION_CHANGE = "@@router/LOCATION_CHANGE";

export interface LocationChangePayload {
  pathname: string;
  search: string;
  hash: string;
}

/* ------------------------       ACTIONS      ------------------------------ */

export const locationChange = createAction<LocationChangePayload>(LOCATION_CHANGE);
